import React, { useState, useEffect } from 'react';
import './css/header.css'; 
import logo from '../assets/images/bola logo png ORIGINAL (1).png';
import { IoMenuOutline, IoCloseOutline } from "react-icons/io5";
import AccommodationPDF from '../assets/Full Board Packages Bolagala Nature Resort.pdf';
import DayOutPDF from '../assets/Day Outing Packages Bolagala Nature Resort.pdf';
import WellnessPDF from '../assets/Wellness.pdf';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  // Toggle the hamburger menu for mobile view
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close the menu when clicked outside
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Handle scroll to change navbar style
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Toggle dropdown visibility for mobile
  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  return (
    <header >
      <div className={`navbar fade-in ${scrolled ? 'scrolled' : ''}`}>
      <div className="logo" id='item1'>
      <h1>Bolagala Nature Resort</h1>
      </div>

      <div className='logoImage' id='item2'>
        <img src={logo} alt="Bolagala Nature Resort Logo" />
      </div>

      <nav>
        <ul>
          <li><a href={AccommodationPDF} target="_blank" rel="noopener noreferrer">Accommodation</a></li>
          <li style={{whiteSpace:'nowrap'}} ><a href={DayOutPDF} target="_blank" rel="noopener noreferrer">Day Out</a></li>
          <li><a href={WellnessPDF} target="_blank" rel="noopener noreferrer">Wellness</a></li>
          <li className="dropdown">
            <a href="#Activities" onClick={toggleDropdown}>Activities</a>
            <ol className={`dropdownMenu ${scrolled ? 'scrolled' : ''} ${dropdownVisible ? 'visible' : ''}`}>
              <li><a href="#PoolTables">Pool Tables</a></li>
              <li><a href="#TableTennis">Table Tennis</a></li>
              <li><a href="#Badminton">Badminton</a></li>
              <li><a href="#DartGames">Dart Games</a></li>
              <li><a href="#KidsPlayground">Kids Playground</a></li>
              <li><a href="#CarromChess">Carrom / Chess</a></li>
            </ol>
          </li>
        </ul>
      </nav>

      {/* Menu Icon (Hamburger) */}
      <div className="menuIcon" onClick={toggleMenu} id='item3'>
        <IoMenuOutline />
      </div>

      
      </div>
      {/* Off-Canvas Menu */}
      {isMenuOpen && (
        <div className="offCanvas">
          <div className="offCanvasOverlay" onClick={closeMenu}></div>
          <div className="offCanvasContent">
            <div className="closeButton" onClick={closeMenu}>
              <IoCloseOutline />
            </div>
            <div className='offcanvaNav'>
              <nav>
                <ul>
                  <li><a href="#home">Home</a></li>
                  <li><a href="#Accommodation">Accommodation</a></li>
                  <li><a href="#DayOut">Day Out</a></li>
                  <li><a href="#Wellness">Wellness</a></li>
                  {/* Dropdown in off-canvas */}
                  <li className="dropdown" >
                    <a href="#services" onClick={toggleDropdown}>Services</a>
                    <ol className={`dropdownMenu ${dropdownVisible ? 'visible' : ''}`} style={{position:'relative'}}>
                      <li><a href="#spa">Spa</a></li>
                      <li><a href="#dining">Dining</a></li>
                    </ol>
                  </li>
                  <li><a href="#activities">Activities</a></li>
                  <li><a href="#contact">Contact</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
